// @flow
import { getCreator } from '../../http';
import environment from '../../environment';

export const endpoints = Object.freeze({
  GET_POPULAR_PRODUCTS: `${environment.apiUrl}/products/popular`,
});

export const getPopularProductsApi = getCreator(fetch, endpoints.GET_POPULAR_PRODUCTS);



// WEBPACK FOOTER //
// ./src/modules/popular-products/api.js